module.exports = __webpack_public_path__ + "img/Carousel-funcionalidades-icono-02.c13d5f6f.svg";